import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { bdsGridModeType } from '@bds/components';
import { RailtracReportsService } from '../../railtrac-reports.service';
import { PageService } from '@bds/core';
import { ReportConstants } from '../../models/report-parameters.model';

@Component({
    selector: 'lib-eta-performance-route',
    templateUrl: './delivery-perf-fleet-business-grp.component.html',
    styleUrl: './delivery-perf-fleet-business-grp.component.css',
})
export class DeliveryPerfFleetBusinessGrpComponent implements OnInit {
    public gridId = 147;
    public gridMode: bdsGridModeType = 'single';
    public apiCall: string = ReportConstants.ReportDataApiCall;
    public pageHeader: string = 'Specialty Request Delivery Performance by Consignee Report';
    public gridSource: any;
    public selectedRowKeys: Array<number> = [];
    public displayReport: boolean = false;
    public controlNames: string[] = ['Begin Date', 'End Date'];

    constructor(public reportService: RailtracReportsService, public pageService: PageService) {}

    ngOnInit() {
        this.pageService.setHeader(this.pageHeader);
    }

    onGetReportClick(event: any) {
        this.displayReport = true;
        this.gridSource = this.reportService.CreateAspNetDatastore(
            ReportConstants.ReportDataApiCall,
            this.gridId.toString(),
            event.startDate,
            event.endDate,
        );
    }

    onCancelClick() {
        this.displayReport = false;
    }

    openTrips(row: any) {
        const ormIds = row?.trip_orm_ids;
        if (!ormIds) {
            return;
        }
        const params = new URLSearchParams({ ormIds: String(ormIds) });
        window.open(`/deliveryPerformanceFleetBusGrpTrips?${params.toString()}`, '_blank');
    }
}
